import React, { Component } from "react";
import GeneralBloc from "../../../bloc/general_bloc";
import "./documents_screen.css";
import { Table, Tabs, Card, Typography, Divider, Collapse, Checkbox, Row, Col, Button, Input } from "antd";
import { RightOutlined, InfoCircleOutlined, UserOutlined, TeamOutlined, EditOutlined, CheckOutlined } from "@ant-design/icons";
import AppFieldError from "../../component/form/app_field_error/app_field_error";
import RouteBloc from "../../../bloc/route_bloc";
import Config from "../../../Config";
import { Redirect, withRouter } from "react-router-dom";
import App_loading_dialog from "../../dialog/app_loading_dialog";
import AdminBloc from "../../../bloc/admin_bloc";
import AuthBloc from "../../../bloc/auth_bloc";
import UtilBloc from "../../../bloc/util_bloc";
import TermsAndConditionDialog from "../../component/terms_and_condition_dialog/terms_and_condition_dialog";
import AppLoadingDialog from "../../dialog/app_loading_dialog";
import BaseScreen from "../base/base_screen/base_screen";
import AppDialog from "../../component/app_dialog/app_dialog";
const { Title, Text } = Typography;
const { TabPane } = Tabs;
const { Panel } = Collapse;

//LoginScreen
class DocumentsScreen extends Component {
  constructor(props) {
    super(props);
    let routeParams = RouteBloc.extractRouteParamsFromProps(props);
    this.state = {
      client: Config.context,
      route: routeParams,
      loaded: false,
      loading: true,
      seconds_remain: 59,
      minutes_remain: 9,
      remain: null,
      checkedValues: [],
      isEditing: false,
      certificateScheduleDetails: {},
      documentData: [
      ]
    };    
  }

  stateCertificateScheduleDetails() {
    return this.state.certificateScheduleDetails;
  }

  stateCertificateMasterScheduleDetails() {
    return this.state.certificateMasterScheduleDetails
  }

  stateMemberDetails() {
    return this.state.memberDetails;
  }

  findRecordsByCertificateNo(records, certificateNo) {
    return records.filter(record => record.certificateNo === certificateNo);
  }

  async getMasterClientInformation() {
    await AdminBloc.getMasterClientInformation().then((result) => {      
      let certificateScheduleDetails = this.findRecordsByCertificateNo(result.data, AuthBloc.getCertificateNo())
      if (result.success && result.data && certificateScheduleDetails.length > 0) {
        this.setState({
          certificateScheduleDetails: certificateScheduleDetails[0],
          certificateMasterScheduleDetails: result.data,
          loading: false,
          loaded: true
        })
      } else {
        this.setState({
          loading: false,
          loaded: true,
          errorCode:result?.errorCode
        })
      }
    }).catch((e) => {
      this.setState({
        loading: false,
        loaded: true
      },()=>{
        this.redirectToLogin();
      })
    })
  }

  async getMemberDetailsInformation() {
    await AdminBloc.getMemberDetailsInformation().then((result) => {

      let data = result.data
      data.correspondenceAddress = [
        data.address1,
        data.address2,
        data.address3,
        data.address4,
        data.postcode
      ]
        .filter(Boolean) // Remove undefined, null, or empty strings
        .join(", ");
      //console.log("DETAILS1", data)
      //console.log("resultresult",result)
      if (result.success && data) {
        this.setState({
          memberDetails: data,
          loading: false,
          loaded: true
        })
      } else {
        this.setState({
          loading: false,
          loaded: true,
          errorCode:result?.errorCode
        })
      }
    }).catch((e) => {
      this.setState({
        loading: false,
        loaded: true
      },()=>{
        this.redirectToLogin();
      })
    })
  }

  stateDocumentCategories() {
    return this.state.documentCategories || [];
  }

  stateDocumentData() {
    return this.state.documentData || [];
  }

  redirectToLogin(){
    sessionStorage.clear();
    localStorage.clear();
    window.location.href = `/${this.state.client}/${Config.routes.generic.login}`;
  }

  async getDocumentCategories() {
    await AdminBloc.getDocumentCategories()
      .then((result) => {
        let data = result.data;
        if (result.success && data) {
          const filteredData = data.filter((item) => item !== "Endorsement");
          this.setState({
            documentCategories: filteredData,
          });
        } else {
          this.setState({
            loading: false,
            loaded: true,
            errorCode: result?.errorCode,
          });
        }
      })
      .catch((e) => {
        this.setState(
          {
            loading: false,
            loaded: true,
          },
          () => {
            this.redirectToLogin();
          }
        );
      });
  }
  

  async getDocumentsByCategory() {
    let payload = {
      "categories": this.state.checkedValues
    };

    await AdminBloc.getDocumentsByCategory(payload).then((result) => {
      let data = result.data
      //console.log("getDocumentsByCategory", JSON.stringify(data))
      if (result.success && data) {
        this.setState({
          documentData: data,
          loading: false
        })
      } else {
        this.setState({
          loading: false,
          loaded: true,
          errorCode:result?.errorCode
        })
      }
    }).catch((e) => {
      this.setState({
        loading: false,
        loaded: true
      },()=>{
        this.redirectToLogin();
      })
    })
  }


  async componentDidMount() {
    await this.getDocumentCategories();
    await this.getMasterClientInformation();
    await this.getMemberDetailsInformation();
  }

  componentWillUnmount() {
    clearInterval(this.myIntervalErrorOtp);
  }

  // Render Loading Content
  loadingContent() {
    return (
      <div style={{ height: "100%", width: "100%" }}>
        <App_loading_dialog isLoading={this.state.loading} />
      </div>
    );
  }

  onChange = (checkedValues) => {
    //console.log("checkedValues", checkedValues)
    this.setState({ checkedValues, loading: true },
      () => {
        this.getDocumentsByCategory()
      }
    );
  };

  goEditPage() {
    window.location.href = `/${this.state.client}/${Config.routes.generic.member_details_screen}/member/edit`
  }

  formatDate(dateStr) {
    if (dateStr.length !== 8) {
      throw new Error("Invalid date string format. Expected YYYYMMDD.");
    }

    const year = dateStr.slice(0, 4);    // Extract the first 4 characters (YYYY)
    const month = dateStr.slice(4, 6);  // Extract the next 2 characters (MM)
    const day = dateStr.slice(6, 8);    // Extract the last 2 characters (DD)

    return `${day}-${month}-${year}`;
  }

  handleIconClick = (record) => {
    //console.log('docId:', record);
    // Add your logic here
    this.setState({
      loading: true,
      fileName: record?.category + "_" + record?.receivedDate + ".pdf"
    },()=>{
      this.getDocumentContentByDocId(record.id);
    })
    
  };

  async getDocumentContentByDocId(docId) {
    await AdminBloc.getDocumentContentByDocId(docId).then(async (result) => {
      if (result.success && result.data.data) {
        let data = await UtilBloc.blobToBase64(result.data.data)
        let content = `data:application/pdf;base64,${data}`;
        this.setState({
          documentContentBlob: result.data.data
        })
        this.openViewDialog("pdf", content);
      } else {
        this.setState({
          openPDFEmpty:true,
          loading: false,
          loaded: true
        })
      }
    }).catch((e) => {
      this.setState({
        loading: false,
        loaded: true,
        openPDFEmpty:true,
      })
    })
  }

  openViewDialog(type, content) {
    this.setState({
      isOpenPDF: true,
      type: type,
      pdfContent: content
    })
  }

  //closeViewDialog
  closeViewDialog() {
    this.setState({
      isOpenPDF: false,
      loading: false
    })
  }

  downloadPDF() {
    UtilBloc.downloadBinary(this.state.documentContentBlob, this.state.fileName)
  }

  loadingContent() {
    return (
      <div style={{ height: "100%", width: "100%" }}>
        <AppLoadingDialog isLoading={this.state.loading} />
      </div>
    );
  }

  getBMVersion(input) {
    const bmTranslations = {
      "Certificate": "Pek Sijil",
      "Certificate Pack": "Pek Sijil",
      "Policy Pack":"Jadual Sijil Takaful",
      "Policy":"Polisi",
      "Notice": "Notis",
      "Renewal Notice":"Notis Pembaharuan",
      "Cancellation Notice":"Notice Pembatalan",
      "Cancellation":"Pembatalan",
      "Contribution Statement":"Penyata Sumbangan",
      "Endorsement": "Endorsmen",
      "Statement": "Penyata",
      "Renewal":"Notis Pembaharuan",
      "Takaful Certificate Schedule":"Jadual Sijil Takaful",
      "All documents relating to Notifications and UL Statement, UL Fund Report":"Penyata Sumbangan"
    };

    // Check if the input exists in the translations map
    if (bmTranslations.hasOwnProperty(input)) {
      return bmTranslations[input];
    } else {
      return "Not Found (BM)"
    }
  }

  handleCheckboxToggle = (value) => {
    const { checkedValues } = this.state;
    if (checkedValues.includes(value)) {
      // Remove the value if it's already checked
      this.setState({
        loading:true,
        checkedValues: checkedValues.filter((item) => item !== value),
      },()=>{
        this.getDocumentsByCategory()
      });
    } else {
      // Add the value if it's not already checked
      this.setState({
        loading:true,
        checkedValues: [...checkedValues, value],
      },()=>{
        this.getDocumentsByCategory()
      });
    }
  };

  render() {
    let columns = [
      {
        title: (
          <span style={{ color: "gray" }}>
            Date / <i>Tarikh</i>
          </span>
        ),
        dataIndex: "receivedDate",
        key: "receivedDate",
      },
      {
        title: (
          <span style={{ color: "gray" }}>
            Document Type / <i>Jenis Dokumen</i>
          </span>
        ),
        dataIndex: "category",
        key: "category",
        render: (text, record) => {          
          // Mapping object for text replacements
          const textMapping = {
            "Renewal": "Renewal Notice",
            "Certificate": "Certificate Pack",
            "Policy Pack": "Takaful Certificate Schedule",
            "All documents relating to Notifications and UL Statement, UL Fund Report":"Contribution Statement"
          };
        
          // Get the mapped display text, fallback to original text if not found
          const displayText = textMapping[text] || text;
        
          return (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span>
                {displayText} / <i>{this.getBMVersion(text)}</i>
              </span>
              <RightOutlined
                style={{ color: "#FF6600", cursor: "pointer" }}
                onClick={() => this.handleIconClick(record)}
              />
            </div>
          );
        },
        
      },
    ];
    

    const options = this.stateDocumentCategories().map((item) => {
      const displayItem = item === "Certificate" ? "Certificate Pack" : item;      
      return {
        label: (
          <div>
            <strong>{displayItem}</strong> / <i><strong>{this.getBMVersion(item)}</strong></i>
          </div>
        ),
        value: item,
      };
    });

    const { isEditing, name, nric, email, editedName, editedNric, editedEmail } =
      this.state;

    return (
      <BaseScreen
      errorCode={this.state.errorCode}
      >
        <div className="no-scroll">
          {
            this.loadingContent()
          }
          <AppDialog
            isOpen={this.state.openPDFEmpty}
            title={""}
            description={"The document could not be displayed because the source was not found. / <i>Dokumen tidak dapat dipaparkan kerana sumber tidak ditemui.</i>"}
            buttonLabel={"Ok"}
            onClick={() => {
              this.setState({
                openPDFEmpty:false
              })
            }}
          />
          <TermsAndConditionDialog
            showClose={true}
            isOpen={this.state.isOpenPDF}
            showDownload={true}
            content={this.state.pdfContent || null}
            onDialogClose={(e) => this.closeViewDialog()}
            downloadPDF={() => {
              this.downloadPDF()
            }}
            type={this.state.type}
          />
          <div className="mt-5" style={{ margin: "20px" }}>
            {/* Top Section - Banner */}
            <div
              className="d-flex align-items-center justify-content-between mb-5"
              style={{ marginBottom: "20px" }}
            >
              <img
                src={
                  GeneralBloc.getAssetsContextPath() +
                  `/assets/images/cuepacs_login_banner.png`
                }
                alt="myCUEPACSCare"
                className="img-fluid"
                style={{ maxWidth: "100%", height: "100px" }}
              />

              <img
                src={
                  GeneralBloc.getAssetsContextPath() +
                  `/assets/icons/logout_icon.png`
                }
                alt="myCUEPACSCare"
                className="img-fluid"
                style={{ maxWidth: "100%", height: "40px",cursor:"pointer" }}
                onClick={(e)=>{
                  sessionStorage.clear();
                  localStorage.clear();
                  window.location.href = `/${this.state.client}/${Config.routes.generic.login}`;
                }}
              />
            </div>

            {/* Main Section - Flex Layout */}
            <div style={{ display: "flex", gap: "20px" }}>
              {/* Left Section - Tabs and Table */}
              <div style={{ flex: "1", padding: "20px", border: "1px solid #f0f0f0", borderRadius: "8px", boxSizing: "border-box", }}>
                <Title level={3} style={{ marginBottom: "20px" }}>
                  Download Document / <i><strong>Muat Turun Dokumen</strong></i>
                </Title>

                {/* Tabs */}
                <div style={{ marginBottom: "20px" }}>
                  <Checkbox.Group
                    value={this.state.checkedValues}
                    onChange={this.onChange}
                    style={{ width: "100%" }}
                  >
                    <Row justify="start" gutter={[16, 16]}>
                      {options.map((option) => (
                        <Col
                          key={option.value}
                          style={{ display: "flex", justifyContent: "flex-start" }}
                        >
                          <div
                            className="checkbox-card"
                            style={{
                              padding: "12px",
                              textAlign: "left",
                              width: "100%",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {/* Image-based checkbox replacement */}
                            <img
                              src={
                                this.state.checkedValues.includes(option.value)
                                  ? GeneralBloc.getAssetsContextPath() +
                                  `/assets/icons/checked_radio_button.png`
                                  : GeneralBloc.getAssetsContextPath() +
                                  `/assets/icons/uncheck_radio_button.png`
                              }
                              alt="checkbox"
                              className="mr-2"
                              onClick={() => this.handleCheckboxToggle(option.value)}
                              style={{ cursor: "pointer",width:"22px",height:"22px" }}
                            />
                            {option.label}
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </Checkbox.Group>
                </div>

                {/* Document Table */}
                {
                  this.stateDocumentData() && this.stateDocumentData().length > 0 && <div>
                    <Table
                      columns={columns}
                      dataSource={this.stateDocumentData()}
                      pagination={false}
                      bordered
                    />
                  </div>
                }

              </div>

              {/* Right Section - Person Details */}
              <div style={{ flex: "0 0 32%", padding: "0px 20px 20px 20px", border: "1px solid #f0f0f0", borderRadius: "8px", boxSizing: "border-box", }}>
                <Collapse defaultActiveKey={["0"]} expandIconPosition="end" style={{ marginTop: "20px" }}>
                  {/* Takaful Certificate Details Section */}
                  <Panel
                    header={
                      <span style={{ color: "black" }}>
                        <img
                          src={
                            GeneralBloc.getAssetsContextPath() +
                            `/assets/icons/Takaful certificate schedule.png`
                          }
                          alt="myCUEPACSCare"
                          style={{ marginRight: "8px", width: "20px", height: "20px", marginLeft: "-2px" }}
                        />
                        Takaful Schedule Certificate Details /<br /> <i>Butiran Jadual Sijil Takaful</i>
                      </span>
                    }
                    key="1"
                  >
                    <Row>
                      <Col span={24}>
                        <Text>Master Certificate no. / <i>No. Sijil Induk</i>:</Text>
                        <div>
                          <strong>
                            {
                              this.stateCertificateScheduleDetails()?.masterCertificateNo || "-"
                            }
                          </strong>
                        </div>
                      </Col>
                    </Row>
                    <Divider />
                    <Row>
                      <Col span={24}>
                        <Text>
                          Takaful Certificate Schedule no. / <i>No. Jadual Sijil Takaful</i>:
                        </Text>
                        <div>
                          <strong>
                            {
                              this.stateCertificateScheduleDetails()?.certificateNo || "-"
                            }
                          </strong>
                        </div>
                      </Col>
                    </Row>
                    <Divider />
                    <Row>
                      <Col span={24}>
                        <Text>Plan Name / <i>Nama Pelan</i>:</Text>
                        <div>
                          <strong>
                            {
                              this.stateCertificateScheduleDetails()?.planName || "-"
                            }
                          </strong>
                        </div>
                      </Col>
                    </Row>
                    <Divider />
                    <Row>
                      <Col span={24}>
                        <Text>Takaful Certificate status / <i>Status Sijil Takaful</i>:</Text>
                        <div>
                          <strong>
                            {
                              this.stateCertificateScheduleDetails()?.certificateStatus?.toUpperCase() || "-"
                            }
                          </strong>
                        </div>
                      </Col>
                    </Row>
                    <Divider />
                    <Row>
                      <Col span={24}>
                        <Text>Commencement Date / <i>Tarikh Kuatkuasa</i>:</Text>
                        <div>
                          <strong>
                            {
                              this.stateCertificateScheduleDetails()?.commencementDate ? this.formatDate(this.stateCertificateScheduleDetails()?.commencementDate.toString()) : "-"
                            }
                          </strong>
                        </div>
                      </Col>
                    </Row>
                    <Divider />
                    <Row>
                      <Col span={24}>
                        <Text>Plan Selection / <i>Pelan Pilihan</i>:</Text>
                        <div>
                          <strong>
                            {
                              this.stateCertificateScheduleDetails()?.planSelection?.toUpperCase() || "-"
                            }
                          </strong>
                        </div>
                      </Col>
                    </Row>
                    <Divider />
                    <Row>
                      <Col span={24}>
                        <Text>Mode of Payment / <i>Kekerapan Pembayaran</i>:</Text>
                        <div>
                          <strong>
                            {
                              this.stateCertificateScheduleDetails()?.modeOfPayment?.toUpperCase() || "-"
                            }
                          </strong>
                        </div>
                      </Col>
                    </Row>
                    <Divider />
                    <Row>
                      <Col span={24}>
                        <Text>Expiry Date / <i>Tarikh Tamat</i>:</Text>
                        <div>
                          {
                            this.stateCertificateScheduleDetails()?.expiryDate?.toUpperCase()=="99-99-9999" ?
                            <strong>
                              Tarikh ulangtahun sijil berikutan hari lahir ke-70 bagi orang dilindungi (ahli)
                            </strong>
                            :
                            <strong>
                            {
                              this.stateCertificateScheduleDetails()?.expiryDate?.toUpperCase() || "-"
                            }
                          </strong>
                          }
                          
                        </div>
                      </Col>
                    </Row>
                  </Panel>
                  {/* Member Details */}
                  <Panel
                    header={
                      <span style={{ color: "black" }}>
                        <img
                          src={
                            GeneralBloc.getAssetsContextPath() +
                            `/assets/icons/member detail.png`
                          }
                          alt="myCUEPACSCare"
                          style={{ marginRight: "8px", width: "20px", height: "20px", marginLeft: "-2px" }}
                        />
                        Member Details / <i>Butiran Ahli</i>
                      </span>
                    }
                    key="2"
                  >
                    <div style={{ marginBottom: 10 }}>
                      <Text>Name / <i>Nama</i>: </Text>
                      <div>
                        <strong>
                          {
                            this.stateMemberDetails()?.memberName?.toUpperCase() || "-"
                          }
                        </strong>
                      </div>
                    </div>

                    <div style={{ marginBottom: 10 }}>
                      <Text>TIN no. / <i>No. Pengenalan Cukai</i>: </Text>
                      {/* <Button
                        type="link"
                        icon={isEditing ? <CheckOutlined /> : <EditOutlined />}
                        onClick={() => {
                          this.goEditPage()
                        }}
                      /> */}
                      <div>
                        <strong>
                          {
                            this.stateMemberDetails()?.memberTaxId || "-"
                          }
                        </strong>
                      </div>
                    </div>

                    <div style={{ marginBottom: 10 }}>
                      <Text>NRIC no. / <i>No. Kad Pengenalan</i>: </Text>
                      <div>
                        <strong>
                          {
                            this.stateMemberDetails()?.memberId || this.stateMemberDetails()?.personCoverNric || "-"
                          }
                        </strong>
                      </div>
                    </div>

                    <div style={{ marginBottom: 10 }}>
                      <Text>Date of Birth / <i>Tarikh Lahir</i>: </Text>
                      <div>
                        <strong>
                          {
                            this.stateMemberDetails()?.memberDob || "-"
                          }
                        </strong>
                      </div>
                    </div>

                    <div style={{ marginBottom: 10 }}>
                      <Text>Mobile No. / <i>No. Telefon Bimbit</i>: </Text>
                      {/* <Button
                        type="link"
                        icon={isEditing ? <CheckOutlined /> : <EditOutlined />}
                        onClick={() => {
                          this.goEditPage()
                        }}
                      /> */}
                      <div>
                        <strong>
                          {
                            this.stateMemberDetails()?.memberMobile ? "+60"+this.stateMemberDetails().memberMobile : "-"
                          }                        
                        </strong>
                      </div>
                    </div>

                    <div style={{ marginBottom: 10 }}>
                      <Text>Email / <i>Emel</i>: </Text>
                      {/* <Button
                        type="link"
                        icon={isEditing ? <CheckOutlined /> : <EditOutlined />}
                        onClick={() => {
                          this.goEditPage()
                        }}
                      /> */}
                      <div>
                        <strong>
                          {
                            this.stateMemberDetails()?.memberEmail || "-"
                          }
                        </strong>
                      </div>
                    </div>

                    <div style={{ marginBottom: 10 }}>
                      <Text>Correspondence address / <i>Alamat Surat-menyurat</i>: </Text>
                      {/* <Button
                        type="link"
                        icon={isEditing ? <CheckOutlined /> : <EditOutlined />}
                        onClick={() => {
                          this.goEditPage()
                        }}
                      /> */}
                      <div>
                        <strong>
                          {
                            this.stateMemberDetails()?.correspondenceAddress?.toUpperCase() || "-"
                          }
                        </strong>
                      </div>
                    </div>
                  </Panel>

                  {/* Person Covered Details */}
                  <Panel
                    header={
                      <span style={{ color: "black" }}>
                        <img
                          src={
                            GeneralBloc.getAssetsContextPath() +
                            `/assets/icons/person_covered.png`
                          }
                          alt="myCUEPACSCare"
                          style={{ marginRight: "8px", width: "18px", height: "18px" }}
                        />
                        Person Covered Details /<br /> <i>Butiran Orang Yang Dilindungi</i>
                      </span>
                    }
                    key="3"
                  >
                    {
                      this.stateCertificateMasterScheduleDetails() &&
                      this.stateCertificateMasterScheduleDetails()?.length > 0 &&
                      this.stateCertificateMasterScheduleDetails().map((item, index) => {
                        return (
                          <div key={index}>
                            <div style={{ marginBottom: 10 }}>
                              <Text>Name / <i>Nama</i>: </Text>
                              <div>
                                <strong>
                                  {item?.personCoverName?.toUpperCase() || "-"}
                                </strong>
                              </div>
                            </div>

                            <div style={{ marginBottom: 10 }}>
                              <Text>NRIC no. / <i>No. Kad Pengenalan</i>: </Text>
                              <div>
                                <strong>
                                  {item?.personCoverNric || "-"}
                                </strong>
                              </div>
                            </div>

                            <div style={{ marginBottom: 10 }}>
                              <Text>Date of Birth / <i>Tarikh Lahir</i>: </Text>
                              <div>
                                <strong>
                                  {item?.personCoverDob || "-"}
                                </strong>
                              </div>
                            </div>

                            <div style={{ marginBottom: 10 }}>
                              <Text>Relationship / <i>Hubungan</i>: </Text>
                              <div>
                                <strong>
                                  {item?.relationship || "-"}
                                </strong>
                              </div>
                            </div>

                            {/* Add horizontal line */}
                            <hr style={{ border: "1px solid #ccc", margin: "20px 0" }} />
                          </div>
                        );
                      })
                    }


                  </Panel>
                </Collapse>

                {/* Footer Help Section */}
                <Card
                  bordered
                  style={{
                    marginTop: "20px",
                    textAlign: "left",
                    fontSize: "12px",
                    lineHeight: "1.2",
                  }}
                  bodyStyle={{
                    padding: "8px 8px 16px 8px", // Adjust padding as needed
                  }}

                >
                  <span>
                    <img
                      src={
                        GeneralBloc.getAssetsContextPath() +
                        `/assets/icons/helpline main.png`
                      }
                      alt="myCUEPACSCare"
                      style={{ marginRight: "8px", width: "16px", height: "16px" }}
                    />
                  </span> <strong>Need Help? / <i><b>Perlukan Bantuan?</b></i></strong>
                  <div className="row mt-2">
                    <div className="col-6 d-flex align-items-start">
                      <i className="bi bi-telephone-fill text-warning fs-2 me-3"></i>
                      <div>
                        <p className="mb-1">
                          <span>
                            <img
                              src={
                                GeneralBloc.getAssetsContextPath() +
                                `/assets/icons/helpline main2.png`
                              }
                              alt="myCUEPACSCare"
                              style={{ marginRight: "8px", width: "14px", height: "14px" }}
                            />
                          </span>
                          <strong>Call us / <i><strong>Hubungi Kami</strong></i></strong>
                        </p>
                        <p className="mb-1"><strong>Medicare Assistance Sdn Bhd</strong></p>
                        <p className="mb-1 fw-bold" style={{ color: "#FF6624" }}>03-33714248</p>
                        <p className="mb-0">Mon-Fri 9am-5pm</p>
                      </div>
                    </div>

                    <div className="col-6 d-flex align-items-start">
                      <i className="bi bi-envelope-fill text-warning fs-2 me-3"></i>
                      <div>
                        <p className="mb-1">
                          <span>
                            <img
                              src={
                                GeneralBloc.getAssetsContextPath() +
                                `/assets/icons/helpline email.png`
                              }
                              alt="myCUEPACSCare"
                              style={{ marginRight: "8px", width: "16px", height: "16px" }}
                            />
                          </span><strong>Send an email / <i><strong>Hantaran Emel</strong></i></strong>
                        </p>
                        <p className="mb-0 fw-bold" style={{
                          color: "#FF6624",
                          wordBreak: "break-word", // Break long words to prevent overflow
                          overflowWrap: "break-word", // Ensures text wraps correctly
                        }}>
                          <a
                            className="helpline-email"
                            target="_blank"
                            rel="noopener"
                            href="mailto:c_service@medicare.org.my"
                          >
                            c_service@medicare.org.my
                          </a>
                        </p>
                      </div>
                    </div>

                  </div>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </BaseScreen>

    );
  }
}

export default withRouter(DocumentsScreen);
